import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommunicationSenderComponent } from './communication-sender.component';
import { TabbedChangerCallbackModule } from '../../shared/tab-changers/tabbed-changer-callback/tabbed-changer-callback.module';
import { UnitSelectorModule } from '../../shared/unit-selector/unit-selector.module';
import { EmailSenderModule } from '../email-sender/email-sender.module';
import { TextSenderModule } from '../text-sender/text-sender.module';
import { PhoneCallSenderModule } from '../phone-call-sender/phone-call-sender.module';
import { MemberSelectorModule } from '../../shared/member-selector/member-selector.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        EmailSenderModule,
        PhoneCallSenderModule,
        TextSenderModule,
        TabbedChangerCallbackModule,
        UnitSelectorModule,
        MemberSelectorModule,
    ],
    declarations: [CommunicationSenderComponent],
    exports: [CommunicationSenderComponent],
})
export class CommunicationSenderCoreModule
{
}
